import styled, { DefaultTheme } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { InvoiceStatus } from '@/features/Profile/sections/Invoices/api';

export const STATUS_COLOR: Record<
  InvoiceStatus,
  (theme: DefaultTheme) => string
> = {
  [InvoiceStatus.Revoked]: () => '#7f8cbb',
  [InvoiceStatus.Canceled]: () => '#a4a4a4',
  [InvoiceStatus.Paid]: theme => theme.palette.system.green,
  [InvoiceStatus.Unpaid]: theme => theme.palette.system.yellow,
  [InvoiceStatus.Overdue]: theme => theme.palette.system.red,
};

export const Status = styled(Typography.Body).attrs({ as: 'span' })<{
  $status: InvoiceStatus;
}>`
  font-weight: 400;
  color: ${({ theme, $status }) => STATUS_COLOR[$status](theme)};
  white-space: nowrap;
`;
